import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import type ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import {
    IS_COPILOT_PROACTIVE_DRAFT_PROPERTY_NAME,
    PROACTIVE_DRAFT_GENERATION_PROPERTIES_NAME,
    PROACTIVE_DRAFT_PROPERTY_SET_ID,
} from './constants';

export default function getProactiveDraftExtendedPropertyUrisForRequest(): ExtendedPropertyUri[] {
    if (
        !isGlobalFeatureEnabled('mon-copilot-proactive-drafts-view') &&
        !isGlobalFeatureEnabled('mon-copilot-proactive-drafts-view-debug')
    ) {
        return [];
    }
    return [
        extendedPropertyUri({
            PropertyName: IS_COPILOT_PROACTIVE_DRAFT_PROPERTY_NAME,
            PropertySetId: PROACTIVE_DRAFT_PROPERTY_SET_ID,
            PropertyType: 'Boolean',
        }),
        extendedPropertyUri({
            PropertyName: PROACTIVE_DRAFT_GENERATION_PROPERTIES_NAME,
            PropertySetId: PROACTIVE_DRAFT_PROPERTY_SET_ID,
            PropertyType: 'String',
        }),
    ];
}
